<template>
  <div class="list_page">
    <!-- 搜索内容 -->
    <div class="filter-container">
      <el-form :inline="true" :model="queryParams" label-width="100px">
        <!-- 问题序号 -->
        <el-form-item label="问题序号">
          <el-input
            v-model="queryParams.questionNum"
            placeholder="请输入问题序号"
          ></el-input>
        </el-form-item>
        <!-- 反馈单号 -->
        <el-form-item label="反馈单号">
          <el-input
            v-model="queryParams.feedbackFormId"
            placeholder="请输入反馈单号"
          ></el-input>
        </el-form-item>
        <!-- VIN -->
        <el-form-item label="VIN">
          <el-input
            v-model="queryParams.vin"
            placeholder="请输入VIN"
          ></el-input>
        </el-form-item>
        <!-- 国家 -->
        <el-form-item label="国家">
          <el-select
            clearable
            filterable
            v-model="queryParams.countryId"
            placeholder="请选择国家"
          >
            <el-option
              v-for="item in nationList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 故障来源 -->
        <el-form-item label="故障来源">
          <el-select
            filterable
            clearable
            v-model="queryParams.carType"
            placeholder="请选择故障来源"
          >
            <el-option label="售前车" :value="0"></el-option>
            <el-option label="售后车" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <!-- 车型 -->
        <el-form-item label="车型">
          <el-select
            filterable
            v-model="queryParams.carModel"
            placeholder="请选择车型"
            clearable
          >
            <el-option
              v-for="item in carTypeList"
              :key="item.codeText"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 车辆属性 -->
        <el-form-item label="车辆属性">
          <el-select
            v-model="queryParams.carAttribute"
            filterable
            clearable
            placeholder="请选择车辆属性"
          >
            <el-option label="燃油车" :value="0"></el-option>
            <el-option label="电动车" :value="1"></el-option>
          </el-select>
        </el-form-item>

        <!-- 故障描述 -->
        <el-form-item label="故障现象描述">
          <el-input
            v-model="queryParams.questionContent"
            placeholder="请输入故障现象描述"
          ></el-input>
        </el-form-item>
        <!-- 提交人 -->
        <el-form-item label="提交人">
          <el-input
            v-model="queryParams.creator"
            placeholder="请输入提交人"
          ></el-input>
        </el-form-item>

        <!-- 处理类型 -->
        <!-- <el-form-item label="处理类型">
          <el-select v-model="queryParams.taskId" filterable clearable>
            <el-option
              v-for="(item, index) in taskList"
              :key="index"
              :label="item.taskName"
              :value="item.taskId"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <!-- 提交时间 -->
        <el-form-item label="提交日期">
          <el-date-picker
            v-model="queryParams.submitTime"
            type="daterange"
            range-separator="-"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <!-- 状态 -->
        <el-form-item label="状态">
          <el-select
            filterable
            clearable
            v-model="queryParams.taskStatus"
            placeholder="请选择状态"
          >
            <el-option label="待处理" :value="0"></el-option>
            <el-option label="处理中" :value="1"></el-option>
            <el-option label="已关闭" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <!-- 当前处理人 -->
        <el-form-item label="当前处理人">
          <el-input
            v-model="queryParams.people"
            placeholder="请输入当前处理人"
          ></el-input>
        </el-form-item>

        <!-- 是否典型问题 -->
        <el-form-item label="是否典型问题" v-if="hasAnyRole(['技术专家'])">
          <el-select filterable clearable v-model="queryParams.typicalProblem">
            <el-option label="是" value="是"></el-option>
            <el-option label="否" value="否"></el-option>
          </el-select>
        </el-form-item>
        <!-- 判定类型 -->
        <!-- <el-form-item label="判定类型">
          <el-select v-model="queryParams.reviewType" filterable clearable>
            <el-option label="未判定" :value="0"></el-option>
            <el-option label="类型一" :value="1"></el-option>
            <el-option label="类型二" :value="2"></el-option>
            <el-option label="类型三" :value="3"></el-option>
            <el-option label="已有解决方案" :value="4"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- 操作 -->
        <el-button type="primary" size="small" @click="doSearch()"
          >查询</el-button
        >
        <el-button type="primary" plain size="small" @click="handleResetQuery()"
          >重置</el-button
        >
      </el-form>
    </div>
    <!-- 表格内容 -->
    <div class="table-container">
      <div class="table-btn">
        <el-button
          type="text"
          size="mini"
          icon="el-icon-download"
          @click="handleExport"
          >导出</el-button
        >
      </div>
      <el-table
        ref="tableRef"
        highlight-current-row
        border
        stripe
        :data="tableData"
        :row-class-name="tableRowClassName"
        fit
      >
        <!-- 序号 -->
        <el-table-column label="序号" width="50px" align="center">
          <template slot-scope="scope">
            {{ getColumnIndex(scope.$index) }}
          </template>
        </el-table-column>
        <!-- 问题序号  -->
        <el-table-column
          prop="questionNum"
          label="问题序号"
          width="130px"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.questionNum }}
          </template>
        </el-table-column>
        <!-- 反馈单号 -->
        <el-table-column
          prop="feedbackFormId"
          label="反馈单号"
          show-overflow-tooltip
          align="center"
          :min-width="$getColumnWidth('feedbackFormId', tableData)"
        >
        </el-table-column>
        <!-- VIN -->
        <el-table-column
          label="VIN"
          width="190px"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="getRowVinList(scope.row).length === 1">
              {{ getRowVinList(scope.row)[0].vin }}
            </span>
            <span
              v-else-if="getRowVinList(scope.row).length > 1"
              class="lineTheme vin-link"
              @click="handleLookAllVin(scope.row)"
            >
              查看VIN列表
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <!-- 故障车数量 -->
        <el-table-column
          label="故障车数量"
          width="90px"
          align="center"
        >
          <template slot-scope="scope">
            {{ getRowVinList(scope.row).length }}
          </template>
        </el-table-column>
        <!-- 是否重点问题 -->
        <el-table-column
          prop="importantType"
          label="是否重点问题"
          width="110px"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.importantType == 1" style="color: #f56c6c"
              >是</span
            >
            <span v-if="scope.row.importantType == 0">否</span>
          </template>
        </el-table-column>
        <!-- 国家 -->
        <el-table-column
          prop="country"
          label="国家"
          show-overflow-tooltip
          :min-width="$getColumnWidth('country', tableData)"
        >
        </el-table-column>
        <!-- 故障来源 -->
        <el-table-column
          label="故障来源"
          show-overflow-tooltip
          :min-width="$getColumnWidth('carType', tableData)"
        >
          <template slot-scope="scope">
            {{ scope.row.carType === 0 ? "售前车" : "售后车" }}
          </template>
        </el-table-column>
        <!-- 车型 -->
        <el-table-column
          prop="carModel"
          label="车型"
          show-overflow-tooltip
          :min-width="$getColumnWidth('carModel', tableData)"
        >
        </el-table-column>
        <!-- 车辆属性 -->
        <el-table-column
          label="车辆属性"
          show-overflow-tooltip
          align="center"
          :min-width="$getColumnWidth('carAttribute', tableData)"
        >
          <template slot-scope="scope">
            {{ scope.row.carAttribute === 0 ? "燃油车" : "电动车" }}
          </template>
        </el-table-column>
        <!-- 故障描述 -->
        <el-table-column
          prop="questionContent"
          label="故障现象描述"
          :min-width="$getColumnWidth('questionContent', tableData)"
        >
          <template slot-scope="scope">
            <span class="gzms">{{ scope.row.questionContent }}</span>
          </template>
        </el-table-column>
        <!-- 提交人 -->
        <el-table-column
          prop="creator"
          label="提交人"
          show-overflow-tooltip
          :min-width="$getColumnWidth('creator', tableData)"
        >
        </el-table-column>
        <!-- 提交时间 -->
        <el-table-column
          prop="submitTime"
          label="提交时间"
          show-overflow-tooltip
          align="center"
          :min-width="$getColumnWidth('submitTime', tableData)"
        >
        </el-table-column>

        <!-- 状态 -->
        <el-table-column
          label="状态"
          show-overflow-tooltip
          align="center"
          :min-width="$getColumnWidth('taskStatus', tableData)"
        >
          <template slot-scope="scope">
            <span class="warnColor">{{
              scope.row.taskStatus === 0 ? "待处理" : ""
            }}</span>
            <span class="blueColor">{{
              scope.row.taskStatus === 1 ? "处理中" : ""
            }}</span>
            <span class="successColor">{{
              scope.row.taskStatus === 2 ? "已关闭" : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="people"
          label="当前处理人"
          show-overflow-tooltip
          width="150px"
        >
        </el-table-column>
        <!-- 操作 -->
        <el-table-column
          label="操作"
          :width="userName==='质量反馈开发'?'370px':'100px'"
          fixed="right"
          align="center"
        >
          <template slot-scope="scope">
            <!-- 查看 -->
            <el-button
              size="mini"
              type="text"
              @click="handleLook(scope.row, scope.$index)"
              >{{
                scope.row.canHandle === 1 &&
                !hasAnyRole(['超级管理员','质量数据查看'])
                  ? "处理"
                  : "查看"
              }}</el-button
            >
            <el-button
              v-if="userName === '质量反馈开发'"
              size="mini"
              type="text"
              @click="handleReset(scope.row)"
              >重置表单</el-button
            >
            <el-button
              v-if="userName === '质量反馈开发'"
              size="mini"
              type="text"
              @click="handleResetQuestion(scope.row)"
              >重置问题</el-button
            >
            <el-button
              v-if="userName === '质量反馈开发'"
              size="mini"
              type="text"
              @click="handleBackQuestion(scope.row)"
            >退回</el-button
            >
            <el-button
              v-if="userName === '质量反馈开发'"
              size="mini"
              type="text"
              @click="handleFinish(scope.row)"
            >关闭</el-button
            >
            <el-button
              v-if="userName === '质量反馈开发'"
              size="mini"
              type="text"
              @click="handleDelete(scope.row)"
            >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="fenye" v-show="total > 0">
        <pagination
          :total="total"
          :page.sync="pageNum"
          :limit.sync="pageSize"
          @pagination="handlePaginationChange"
        />
      </div>
    </div>
    <vin-list-dialog ref="vinListDialog" />
  </div>
</template>
<script>
import VinListDialog from "./vinListDialog.vue";
import listCurd from "@/mixins/listCurd";
import {
  problemListApi,
  problemExportApi,
  problemQuestionDetailApi,
  feedbackFormReset, feedbackQuestionReset, feedbackFormFinish, feedbackQuestionBack,
} from "@/api/feedback";
import { getDownloadFiles } from "@/util/downFile";
import { getDictItem } from "@/util/dict";
import { setStorageNew, getSession } from "@/util/localStor";
import { taskIdData } from "../utils";
import { feedbackFormDelete } from '../../../../api/feedback'
import { getCurrentRoles, hasAnyRole } from "@/utils/role";

export default {
  components: { VinListDialog },
  mixins: [listCurd],
  props: {
    taskList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      userRoles: getCurrentRoles(),
      userName: sessionStorage.getItem("name"),
      taskIdData,
      reviewTypeList: [
        { id: 1, name: "类型一" },
        { id: 2, name: "类型二" },
        { id: 3, name: "类型三(应急措施、根因分析、永久方案)" },
        { id: 4, name: "已有解决方案" },
      ],
      // 国家
      nationList: Object.values(getSession("nationList")).slice(1),
      // 车型
      carTypeList: [],
      // 查询参数
      queryParams: {},
      type: "problem",
      // 表格数据
      listMethod: problemListApi,
    };
  },
  created() {
    // 获取车型列表
    this.getCarTypeList();
    // 获取表格数据
    this.getList();
  },
  mounted() {
    this.$router.replace(this.$route.path);
  },
  methods: {
    hasAnyRole,
    getRowVinList(row = {}) {
      if (Array.isArray(row.vinCheckRespList) && row.vinCheckRespList.length) {
        const vinSet = new Set();
        return row.vinCheckRespList.filter((item) => {
          if (!item || !item.vin || vinSet.has(item.vin)) {
            return false;
          }
          vinSet.add(item.vin);
          return true;
        });
      }
      return row.vin ? [{ vin: row.vin }] : [];
    },
    // 查看完整 VIN 列表
    handleLookAllVin(row = {}) {
      this.$refs.vinListDialog.init(
        "查看全部",
        row.carAttribute,
        row.faultType,
        this.getRowVinList(row)
      );
    },
    // 查询参数
    getParams() {
      const params = { ...JSON.parse(JSON.stringify(this.queryParams)) };
      if ((params.submitTime || []).length === 2) {
        params.submitTimeStart = params.submitTime?.[0];
        params.submitTimeEnd = params.submitTime?.[1];
      }
      delete params.submitTime;
      return {
        data: {
          ...params,
        },
        page: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        },
      };
    },
    // 获取车型列表
    async getCarTypeList() {
      this.carTypeList = await getDictItem("carType");
      // localStorage.getItem("problemData")
    },
    // 查看
    handleLook(data = {}, index) {
      // 记录当前筛选条件
      // this.recordSearchObj();
      let urlSearchParams = new URLSearchParams();
      urlSearchParams.append("taskId", data.taskId);
      problemQuestionDetailApi(urlSearchParams).then((res) => {
        if (res.status == 0) {
          var list = res.data;
          localStorage.setItem("problemId", list.questionId);
          setStorageNew("problemData", list);
          localStorage.setItem("createTime", list.createTime);
          this.getSetItem();
          this.$nextTick(() => {
            this.$router.push({
              path: "/problemDetailNew/" + list.taskId,
              query: {
                questionNum: list.questionNum,
                searchObj: JSON.stringify({
                  data: {
                    ...this.getParams().data,
                  },
                  page: {
                    pageNum: this.getColumnIndex(index),
                    pageSize: 1,
                  },
                }),
              },
            });
          });
        }
      });
    },
    // 重置表单
    handleReset(row) {
      this.$confirm("确认重置当前反馈单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        feedbackFormReset(row.feedbackFormId).then((res) => {
          if (res.status == 0) {
            this.$DonMessage.success("重置成功!");
            this.getList();
          } else {
            this.$DonMessage.error(res.message);
          }
        });
      });
    },
    // 重置问题
    handleResetQuestion(row) {
      this.$confirm("确认重置当前问题?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        feedbackQuestionReset(row.questionId).then((res) => {
          if (res.status == 0) {
            this.$DonMessage.success("重置成功!");
            this.getList();
          } else {
            this.$DonMessage.error(res.message);
          }
        });
      });
    },
    // 重置问题
    handleBackQuestion(row) {
      this.$confirm("确认退回当前问题?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        feedbackQuestionBack(row.questionId).then((res) => {
          if (res.status == 0) {
            this.$DonMessage.success("退回成功!");
            this.getList();
          } else {
            this.$DonMessage.error(res.message);
          }
        });
      });
    },
    handleFinish(row) {
      this.$confirm("确认关闭当前问题?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        feedbackFormFinish(row.questionId).then((res) => {
          if (res.status == 0) {
            this.$DonMessage.success("关闭成功!");
            this.getList();
          } else {
            this.$DonMessage.error(res.message);
          }
        });
      });
    },
    handleDelete(row) {
      this.$confirm("确认删除当前问题及其反馈单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        feedbackFormDelete(row.feedbackFormId).then((res) => {
          if (res.status == 0) {
            this.$DonMessage.success("删除成功!");
            this.getList();
          } else {
            this.$DonMessage.error(res.message);
          }
        });
      });
    },
    // 导出
    async handleExport() {
      const params = this.getParams();
      const res = await problemExportApi({ data: params.data });
      getDownloadFiles(res);
      if (res.fileName) {
        this.$DonMessage.success("导出成功！");
      }
    },
    // 颜色填充
    tableRowClassName({ row, rowIndex }) {
      if (row.taskStatus === 1 || row.taskStatus === 2) {
        return "success-row";
      }
      return "";
    },
  },
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>
<style lang="scss" scoped>
.vin-link {
  font-size: 12px;
}
</style>
